import React, { Fragment, useState, useEffect, useMemo } from 'react';

import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';

import { Add } from '@material-ui/icons';

import FilterArticle from '../../Filters/FilterArticle';

const productTableColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 75 },
  { Header: 'Código', accessor: 'ItemCode', width: 100 },
  { Header: 'Producto', accessor: 'ItemName' },
  { Header: 'Categoría', accessor: 'category', width: 150 },
  { Header: 'Familia', accessor: 'family', width: 190 },
  { Header: 'Agregar', accessor: 'actions', excelEnabled: false, width: 80 }
];

export default function Product(props) {
  const promo = props.promo;
  const { providers, categories, families } = props;

  const statePromo = promo.state == 'N' || promo.state == 'G' ? false : true;

  const [warehouses, setWarehouses] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {}, [promo]);

  const colums = useMemo(() => {
    if (warehouses.length === 0) {
      return productTableColumns;
    }
    let columns = [];
    let index = productTableColumns.findIndex(item => item.accessor === 'family');
    for (let i = 0; i <= index; i++) {
      columns.push(productTableColumns[i]);
    }
    for(let warehouse of warehouses){
      columns.push({
        Header: warehouse.WhsName.replace('Almacén', ''),
        accessor: `WHS-${warehouse.id}`,
        width: 85,
      });
    }
    for (let i = index + 1; i < productTableColumns.length; i++) {
      columns.push(productTableColumns[i]);
    }
    return columns;
  }, [warehouses]);

  return (
    <Fragment>
      <FilterArticle
        promo={props.promo}
        providers={providers}
        categories={categories}
        families={families}
        listCategories={props.listCategories}
        listFamilies={props.listFamilies}
        setCategories={props.setCategories}
        setFamilies={props.setFamilies}
        setProducts={setProducts}
        setWarehouses={setWarehouses}
      />
      <ReactTable
        exportExcel={false}
        heightRow={50}
        columns={colums}
        data={products.map((product, i) => {
          let stockData = {};
          if(product.stocks !== undefined){
            for(let stock of product.stocks){
              stockData[`WHS-${stock.logi_warehouse_id}`] =
                parseFloat(stock.OnHand) - parseFloat(stock.IsCommited);
            }
          }
          return {
            num: i + 1,
            ItemCode: product.ItemCode,
            ItemName: product.ItemName,
            category: product.category?.description,
            family: product.family?.description,
            ...stockData,
            actions: (
              <div className="actions-right">
                <Button
                  justIcon
                  color="success"
                  className="like"
                  size="sm"
                  round
                  onClick={() => {
                    props.addProduct(product);
                  }}
                  disabled={statePromo}
                >
                  <Add />
                </Button>
              </div>
            ),
          };
        })}
      />
    </Fragment>
  );
}
